// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2ofg9","list":"PatternAutocomplete_list__2w5QR"};